<template>
  <NavbarTop />
  <NavbarBottom />
  <router-view />
</template>

<script>
import "./css/app.css";
import NavbarTop from "./components/Nabvar_Top.vue";
import NavbarBottom from "./components/Nabvar_Bottom.vue";
import useUserStore from "./stores/userStore";
import { onMounted } from "vue";

export default {
  components: {
    NavbarTop,
    NavbarBottom,
  },
  setup() {
    const userStore = useUserStore();

    onMounted(() => {
      userStore.loadUserFromStorage();
    });

    return {
      userStore,
    };
  },
};
</script>
